import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const NotFound = () => {
    return (
        <>
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f8f9fa',
                color: '#333',
                fontFamily: 'sans-serif',
                textAlign: 'center',
                padding: '20px 20px 100px 20px', // Added bottom padding
                boxSizing: 'border-box'
            }}>
                <h1 style={{ fontSize: '4rem', margin: '0 0 20px 0', color: '#e74c3c' }}>404</h1>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>Page Not Found</h2>
                <p style={{ color: '#666', marginBottom: '30px', maxWidth: '400px' }}>
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </p>
                <Link to="/" style={{
                    textDecoration: 'none',
                    backgroundColor: '#333',
                    color: 'white',
                    padding: '10px 25px',
                    borderRadius: '5px',
                    fontWeight: 'bold'
                }}>
                    Go to Home
                </Link>
            </div>
            <Footer />
        </>
    );
};

export default NotFound;
